import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./components/App";
import './index.scss'

ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
).render(<App token={new URLSearchParams(window.location.search).get('token') ?? undefined}
              refresh={new URLSearchParams(window.location.search).get('refresh') ?? undefined}/>)
